import * as actionTypes from './action-types-enCorrect';

export const actionCreatorUpdateAllData = (val) => {
  return {
    type: actionTypes.UPDATE_ALLDATA,
    data: val
  };
};

export const actionCreatorUpdateOverall = (val) => {
  return {
    type: actionTypes.UPDATE_OVERALL,
    data: val
  };
};

export const actionCreatorUpdateError = (val) => {
  return {
    type: actionTypes.UPDATE_ERROR,
    data: val
  };
};
export const actionCreatorUpdateSuggestion = (val) => {
  return {
    type: actionTypes.UPDATE_SUGGESTION,
    data: val
  };
};
export const actionCreatorUpdateConjunction = (val) => {
  return {
    type: actionTypes.UPDATE_CONJUNCTION,
    data: val
  };
};
export const actionCreatorUpdatePhrase = (val) => {
  return {
    type: actionTypes.UPDATE_PHRASES,
    data: val
  };
};
export const actionCreatorUpdateClause = (val) => {
  return {
    type: actionTypes.UPDATE_CLAUSE,
    data: val
  };
};

export default {
  actionCreatorUpdateOverall
};
